module.exports = __webpack_public_path__ + "img/feat_safe.ef6cd6c3.png";